// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { NavLink } from 'react-router';
import { Chip, Tooltip } from '@mui/material';
import { AppIcon } from '@shared/ui-kit/components/app-icon';
import { defineComponent } from '@shared/ui-kit/utils/define-component';
import { classNames } from '@shared/ui-kit/utils';
import { useClientProfileLink } from './use-client-profile-link';
import styles from './client-profile-link.module.css';
import { Translation } from '@shared/ui-kit/providers';

export const ClientProfileLink = defineComponent({
  displayName: 'ClientProfileLink',
  useSetup: useClientProfileLink,
  View: ({
    expanded,
    hidden,
    profileMetadata,
    hasRiskProfile,
    chipLabel,
    isActive,
  }) => {
    return (
      <Tooltip
        title={<Translation i18nKey="common.profile" ns="common" />}
        placement="right"
        arrow
      >
        <span>
          <NavLink
            to="/profile"
            className={({ isActive }) =>
              classNames(styles.link, {
                [styles['link-active']]: isActive,
                [styles['link-hidden']]: hidden,
              })
            }
            key="/profile"
            data-aria-expanded={expanded}
            data-active={isActive ? 'true' : undefined}
            data-testid="client-profile-link"
          >
            <AppIcon icon="Person" size={16} />
            <span
              className={classNames(styles['link-title'], {
                [styles['link-title-hidden']]: !expanded,
              })}
              aria-hidden={!expanded}
            >
              <Translation i18nKey="common.profile" ns="common" />
            </span>
            {expanded && hasRiskProfile && profileMetadata && (
              <Chip
                label={chipLabel}
                variant="filled"
                size="medium"
                icon={
                  <span className={styles['chip-icon']}>
                    <AppIcon
                      icon={profileMetadata.icon}
                      size={12}
                      className={styles[`icon-${profileMetadata.type}`]}
                    />
                  </span>
                }
                className={classNames(
                  styles.chip,
                  styles[`chip-${profileMetadata.type}`],
                )}
                data-testid="client-profile-risk-badge"
              />
            )}
          </NavLink>
        </span>
      </Tooltip>
    );
  },
});
